import React from 'react';
import StockTablePage from '../../components/monitor/StockTablePage';

export default function WIP() {
  return <StockTablePage title="WIP IN LOW CARE" category="WIP" />;
}
